import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaPlus, FaSave } from "react-icons/fa";
import { useRef } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {TextStyle} from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";

const quillModules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ color: [] }],        // 👈 font color picker
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

const quillFormats = [
  "bold",
  "italic",
  "underline",
  "color",
  "list",
  "bullet",
];
export function AdminSectionEditor({ value, onChange }) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      TextStyle,
      Color,
    ],
    content: value || "",
  editorProps: {
  attributes: {
    class: "p-2 min-h-[120px] focus:outline-none",
  },
},


    // 🔥 AUTO-HIGHLIGHT ON EVERY CHANGE
    onTransaction({ editor, transaction }) {
      // only apply when admin types (not programmatic updates)
      if (transaction.docChanged) {
        editor
          .chain()
          .setMark("bold")
          .setColor("red")
          .run();
      }
    },

    onUpdate({ editor }) {
      onChange(editor.getHTML());
    },
  });

  return <div className="admin-editor-wrapper">
    <EditorContent editor={editor} />
  </div>
}

export default function AdminResearchEditor() {
  const { id } = useParams();
  const [paper, setPaper] = useState(null);

  // 🔹 CONTENT EDITING (FOR CUSTOMER APPROVAL)
  const [editedAbstract, setEditedAbstract] = useState("");
  const [editedSections, setEditedSections] = useState([]);
const [pdfUrl, setPdfUrl] = useState(null);
const [showPdfMenu, setShowPdfMenu] = useState(false);
  // 🔹 NOTES (UNCHANGED FUNCTIONALITY)
  const [adminNotes, setAdminNotes] = useState({});
  const [openNote, setOpenNote] = useState(null);
  const [showPdf, setShowPdf] = useState(null);
const quillRef = useRef(null);
  useEffect(() => {
    fetchPaper();
  }, []);

 const fetchPaper = async () => {
  const res = await api.get(`/api/research-papers/${id}`);
  setPaper(res.data);

  const originalSections = JSON.parse(res.data.sectionsJson || "[]");

  setEditedSections(
    originalSections.map(sec => ({
      ...sec,
      originalContent: sec.content, // ⭐ IMPORTANT
    }))
  );

  setEditedAbstract(res.data.abstractText || "");
  setAdminNotes(
    res.data.adminNotes ? JSON.parse(res.data.adminNotes) : {}
  );
};

 
const openPdf = async (type) => {
  try {
    const res = await api.get(
      `/api/research-papers/pdf/${id}/${type}`,
      { responseType: "blob" }
    );

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    setPdfUrl(url);      // 👈 store blob url
    setShowPdf(type);   // 👈 open modal
  } catch (err) {
    console.error(err);
    alert("Unable to open PDF");
  }
};
  /* ============================
     🟢 SAVE ADMIN NOTES (OLD)
     ============================ */
  const saveNotes = async () => {
    await api.put(
      `/api/research-papers/admins/notes/${id}`,
      JSON.stringify(adminNotes),
      { headers: { "Content-Type": "text/plain" } }
    );
    alert("Admin notes saved");
  };

  /* ============================
     🔥 SEND ADMIN CONTENT EDITS
     ============================ */
const sendEditsForReview = async () => {

  const changedSections = editedSections
    .filter(sec =>
      sec.content &&
      sec.content.trim() !== sec.originalContent?.trim()
    )
    .map(sec => ({
      heading: sec.heading,
      content: sec.originalContent,      // original
      suggestedContent: sec.content,      // admin edit
      suggested: true,
      reviewStatus: "PENDING",
    }));

  if (changedSections.length === 0) {
    alert("No section changes detected");
    return;
  }

  await api.put(`/api/research-papers/admins/suggest/${id}`, {
    abstractText: editedAbstract,
    sectionsJson: JSON.stringify(changedSections),
  });

  alert("Admin content edits sent to customer for review");
};

  if (!paper) return <p>Loading...</p>;

  return (
    <div className="container mt-4">
 
 <div className="d-flex align-items-center gap-3">
  <h3 className="mb-0">{paper.title}</h3>

  <button
    className="btn btn-primary btn-sm"
    onClick={() => setShowPdfMenu(!showPdfMenu)}
  >
    📄 View PDFs
  </button>
</div>

{/* 🔽 Animated PDF menu */}
<div className={`pdf-menu ${showPdfMenu ? "open" : ""}`}>
  <button onClick={() => openPdf("NOC")}>📄 NOC</button>
  <button onClick={() => openPdf("IEC_CLEARANCE")}>📄 IEC Clearance</button>
  <button onClick={() => openPdf("UNIVERSITY_APPROVAL")}>📄 University Approval</button>
  <button onClick={() => openPdf("FINAL_RESULTS")}>📄 Final Results</button>
  <button onClick={() => openPdf("LICENSING_AGREEMENT")}>📄 Licensing Agreement</button>
</div>


{showPdf && (
  <div
    className="modal fade show"
    style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
  >
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">
            {showPdf.replace("_", " ")}
          </h5>
          <button
            className="btn-close"
            onClick={() => {
              URL.revokeObjectURL(pdfUrl);
              setPdfUrl(null);
              setShowPdf(null);
            }}
          />
        </div>

        <div className="modal-body" style={{ height: "80vh" }}>
          <iframe
            src={pdfUrl}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      </div>
    </div>
  </div>
)}

 <style>
{`
.pdf-menu {
  max-height: 0;
  overflow: hidden;
  transition: all 0.35s ease;
  margin-top: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.pdf-menu.open {
  max-height: 200px;
}
.ql-editor {
  min-height: 120px;
  line-height: 1.6;
}

.pdf-menu button {
  border: 1px solid #0d6efd;
  background: white;
  color: #0d6efd;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
}

.pdf-menu button:hover {
  background: #0d6efd;
  color: white;
}
`}
</style>
<style>
{`
/* ===============================
   TIPTAP TEXTAREA LOOK & FEEL
================================ */

.admin-editor-wrapper {
  background-color: #fff;
  padding: 0;
  min-height: 140px;
}


/* actual editable area */
.admin-editor-wrapper .ProseMirror {
  min-height: 120px;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.6;

  white-space: pre-wrap;
  width: 100%;
  max-width: 100%;
}


/* placeholder spacing fix */
.admin-editor-wrapper .ProseMirror p {
  margin: 0;
}

/* focus state (like input focus) */
.admin-editor-wrapper:focus-within {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.15rem rgba(13, 110, 253, 0.25);
}

/* red admin-highlighted text */
.admin-editor-wrapper .ProseMirror strong {
  font-weight: 600;
}

.admin-editor-wrapper .ProseMirror span[style*="color:red"] {
  color: #dc3545 !important;
}
`}
</style>

      {/* ================= ABSTRACT ================= */}
      <div className="border p-3 mt-4">
        <h5>
          Abstract (Editable){" "}
          <FaPlus
            style={{ cursor: "pointer" }}
            onClick={() => setOpenNote("abstract")}
          />
        </h5>

        {/* 📝 ADMIN CONTENT EDIT */}
        <ReactQuill
          value={editedAbstract}
          onChange={setEditedAbstract}
        />

        {/* 📝 ADMIN NOTES (OLD FEATURE) */}
        {openNote === "abstract" && (
          <textarea
            className="form-control mt-2"
            rows="3"
            placeholder="Admin questions for abstract"
            value={adminNotes.abstract || ""}
            onChange={(e) =>
              setAdminNotes({ ...adminNotes, abstract: e.target.value })
            }
          />
        )}
      </div>

      {/* ================= SECTIONS ================= */}
      {editedSections.map((sec, idx) => (
        <div key={idx} className="border p-3 mt-4">
          <h5>
            {sec.heading}{" "}
            <FaPlus
              style={{ cursor: "pointer" }}
              onClick={() => setOpenNote(sec.heading)}
            />
          </h5>

          {/* 📝 ADMIN CONTENT EDIT */}
   <div className="border rounded p-3">
  <AdminSectionEditor
    value={sec.content}
    onChange={(html) => {
      const updated = [...editedSections];
      updated[idx].content = html;
      setEditedSections(updated);
    }}
  />
</div>


          {/* 📝 ADMIN NOTES (OLD FEATURE) */}
          {openNote === sec.heading && (
            <textarea
              className="form-control mt-2"
              rows="3"
              placeholder={`Admin notes for ${sec.heading}`}
              value={adminNotes[sec.heading] || ""}
              onChange={(e) =>
                setAdminNotes({
                  ...adminNotes,
                  [sec.heading]: e.target.value,
                })
              }
            />
          )}
        </div>
      ))}

      {/* ================= ACTION BUTTONS ================= */}
      <div className="d-flex gap-3 mt-4">
        <button className="btn btn-success" onClick={saveNotes}>
          <FaSave /> Save Admin Notes
        </button>

        <button className="btn btn-danger" onClick={sendEditsForReview}>
          Send Content Changes to Customer
        </button>
      </div>
    </div>
  );
}
